import { Observable } from 'rxjs';
import { RRIBaseModel } from './base-model.interface';
import { RRIQueryParams } from './base-query-params.interface';
import { RRITableData } from './table/table-data.interface';

export interface RRIBaseService<T extends RRIBaseModel, U> {
  getData(
    params?: RRIQueryParams<T, U>,
    forceReload?: boolean,
  ): Observable<RRITableData<T>>;
  deleteEntry(entry: T): Observable<T>;
  updateEntry(entry: T): Observable<T>;
  deleteMultipleEntries?(entries: T[]): Observable<T[]>;
}
